module.exports = __webpack_public_path__ + "static/media/9DESA16.40fcb87e.jpg";